import PropTypes from "prop-types";

import { alignItems } from "../../consts";
import { t } from "../../services";

import { WrapperContainer, FlexContainers } from "../../components";
import RadioInput from "./RadioInput";

const RadioGroup = ({ name, options, selectedId, onChange }) => {
  return (
    <WrapperContainer
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      gap={10}
    >
      {options?.map((option) => {
        const { id } = option;

        return (
          <RadioInput
            key={id}
            id={id}
            name={name}
            checkedId={selectedId}
            onCheck={onChange}
          >
            {t(option.value)}
          </RadioInput>
        );
      })}
    </WrapperContainer>
  );
};

RadioGroup.propTypes = {
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      value: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onChange: PropTypes.func.isRequired
};

export default RadioGroup;
